import React from 'react';

interface ServiceData {
  serviceId: string;
  priority: string;
  focusAreas: string[];
}

interface Capability {
  label: string;
  value: string;
  highlight?: boolean;
}

interface TerminalSectionProps {
  delay: string;
  icon: string;
  title: string;
  type: 'info' | 'console' | 'capabilities';
  data?: ServiceData;
  consoleLines?: string[];
  capabilities?: Capability[];
}

const TerminalSection: React.FC<TerminalSectionProps> = ({ 
  delay, 
  icon, 
  title, 
  type, 
  data, 
  consoleLines, 
  capabilities 
}) => {
  const renderContent = (): JSX.Element | null => {
    switch (type) {
      case 'info':
        if (!data) return null;
        return (
          <div className="info-panel">
            <div className="info-panel-grid">
              <div className="info-item">
                <div className="info-label">Service ID</div>
                <div className="info-value">{data.serviceId}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Priority</div>
                <div className="info-value highlight">{data.priority}</div>
              </div>
              <div className="info-item">
                <div className="info-label">Focus Areas</div>
                <div className="info-value">
                  <div className="tags-container">
                    {data.focusAreas.map((area, index) => (
                      <span key={index} className="tag">{area}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 'console':
        if (!consoleLines) return null;
        return (
          <div className="console-output">
            {consoleLines.map((line, index) => (
              <div key={index} className="console-line">
                {line.includes('$') ? (
                  <>
                    <span className="prompt">$</span>
                    {line.replace('$', '').includes('enterprise resources ready') || 
                     line.replace('$', '').includes('launching soon') ? (
                      <>
                        {line.replace('$', '').split(':')[0]}:
                        <span className="console-success">
                          {line.replace('$', '').split(':')[1]}
                        </span>
                        {line.includes('launching soon') && <span className="cursor"></span>}
                      </>
                    ) : (
                      line.replace('$', '')
                    )}
                  </>
                ) : (
                  line
                )}
              </div>
            ))}
          </div>
        );
      
      case 'capabilities':
        if (!capabilities) return null;
        return (
          <div className="info-panel">
            <div className="info-panel-grid">
              {capabilities.map((capability, index) => (
                <div key={index} className="info-item">
                  <div className="info-label">{capability.label}</div>
                  <div className={`info-value ${capability.highlight ? 'highlight' : ''}`}>
                    {capability.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="terminal-section" style={{ animationDelay: delay }}>
      <div className="section-heading">
        <span className="section-icon">{icon}</span>
        <h3 className="section-title">{title}</h3>
      </div>
      {renderContent()}
    </div>
  );
};

export default TerminalSection;
